import { render, staticRenderFns } from "./CarrierMarss.vue?vue&type=template&id=38231c00&scoped=true&"
import script from "./CarrierMarss.vue?vue&type=script&lang=js&"
export * from "./CarrierMarss.vue?vue&type=script&lang=js&"
import style0 from "./CarrierMarss.vue?vue&type=style&index=0&id=38231c00&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38231c00",
  null
  
)

export default component.exports